module.exports = __webpack_public_path__ + "static/media/87.5d4f94db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/87.svg
// module id = 173
// module chunks = 0